import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.svg'
import _imports_1 from '@/assets/images/logo-white.svg'


const _hoisted_1 = { class: "row align-items-center header-inner-area" }
const _hoisted_2 = { class: "col-lg-5 col-sm-6" }
const _hoisted_3 = { class: "left-header-content" }
const _hoisted_4 = { class: "d-flex align-items-center ps-0 mb-0 list-unstyled justify-content-center justify-content-sm-start" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = { class: "burger-menu" }
const _hoisted_7 = { class: "col-lg-7 col-sm-6" }
const _hoisted_8 = { class: "right-header-content mt-2 mt-sm-0" }
const _hoisted_9 = { class: "d-flex align-items-center justify-content-center justify-content-sm-end ps-0 mb-0 list-unstyled" }
const _hoisted_10 = { class: "header-right-item me-2" }
const _hoisted_11 = { class: "header-right-item" }
const _hoisted_12 = { class: "header-right-item" }
const _hoisted_13 = { class: "header-right-item" }
const _hoisted_14 = { class: "header-right-item" }
const _hoisted_15 = { class: "header-right-item" }
const _hoisted_16 = { class: "header-right-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SearchFrom = _resolveComponent("SearchFrom")!
  const _component_WebApps = _resolveComponent("WebApps")!
  const _component_PeriodeFilter = _resolveComponent("PeriodeFilter")!
  const _component_DarkSwtichBtn = _resolveComponent("DarkSwtichBtn")!
  const _component_LanguageMenu = _resolveComponent("LanguageMenu")!
  const _component_ToggleFullscreenBtn = _resolveComponent("ToggleFullscreenBtn")!
  const _component_NotificationsLists = _resolveComponent("NotificationsLists")!
  const _component_AdminProfile = _resolveComponent("AdminProfile")!
  const _component_SettingsBtn = _resolveComponent("SettingsBtn")!
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
      'header-area bg-white mb-4 rounded-bottom-15',
      { sticky: _ctx.isSticky },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_RouterLink, {
                to: "/dashboard",
                class: "d-block text-decoration-none"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    class: "logo-black",
                    src: _imports_0,
                    alt: "logo-icon"
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "logo-white",
                    src: _imports_1,
                    alt: "logo-icon"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["header-burger-menu bg-transparent p-0 border-0", [
                  'header-burger-menu bg-transparent p-0 border-0',
                  { active: _ctx.stateStoreInstance.open },
                ]]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "menu", -1)
              ]))], 2)
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_SearchFrom)
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_WebApps)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_PeriodeFilter)
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_DarkSwtichBtn)
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_LanguageMenu)
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_ToggleFullscreenBtn)
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createVNode(_component_NotificationsLists)
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_AdminProfile)
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createVNode(_component_SettingsBtn)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Navbar)
  ], 2))
}